export default {
  SET_TOKEN: "SPREEDLY/SET_TOKEN",
  SET_VALIDITY: "SPREEDLY/SET_VALIDITY",
  SET_VALIDATION_ERRORS: "SPREEDLY/SET_ERRORS",
  SET_TRIGGER_VALIDATION: "SPREEDLY/SET_TRIGGER_VALIDATION",
};
